/* Bravado Labs: welcome popup. Scratch the foil to reveal the offer, enter an email to claim the code.
   Opens on every page load once the shopper scrolls past the main banner; prototype only, nothing is sent. */
(() => {
  const OFFER = "10% off", CODE = "WELCOME10";
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const pop = document.createElement("div");
  pop.className = "pop"; pop.hidden = true;
  pop.innerHTML = `
    <div class="pop-card" role="dialog" aria-modal="true" aria-labelledby="pop-h">
      <button type="button" class="pop-x" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
      <span class="pop-logo" aria-hidden="true"></span>
      <p class="pop-kick">A welcome gift</p>
      <h2 id="pop-h">Scratch to reveal <span>your discount.</span></h2>
      <div class="pop-scratch">
        <div class="pop-prize" aria-live="polite"><b>${OFFER}</b><span>your first order</span></div>
        <canvas class="pop-foil" aria-hidden="true"></canvas>
      </div>
      <button type="button" class="pop-reveal">Can't scratch? Reveal it</button>
      <form class="pop-form" novalidate hidden>
        <label for="pop-email">Enter your email to claim ${OFFER}</label>
        <div class="pop-row"><input id="pop-email" type="email" autocomplete="email" placeholder="you@example.com" required><button type="submit">Claim ${OFFER}</button></div>
        <p class="pop-err" role="alert"></p>
      </form>
      <div class="pop-done" hidden>
        <p>Your code is ready. Use it at checkout:</p>
        <button type="button" class="pop-code" aria-label="Copy code ${CODE}"><b>${CODE}</b><span>Copy</span></button>
      </div>
      <p class="pop-fine">One use per customer. By signing up you agree to receive emails from Bravado Labs. Unsubscribe anytime.</p>
      <button type="button" class="pop-no">No thanks</button>
    </div>`;
  document.body.append(pop);
  const card = $(".pop-card", pop), canvas = $(".pop-foil", pop), form = $(".pop-form", pop), input = $("#pop-email", pop);
  let revealed = false, lastFocus = null;

  /* ---------- the foil: amber, hexagon print, "scratch here"; erased with the pointer ---------- */
  const ctx = canvas.getContext("2d");
  const paint = () => {
    const r = canvas.parentElement.getBoundingClientRect(), dpr = Math.min(devicePixelRatio || 1, 2);
    canvas.width = r.width * dpr; canvas.height = r.height * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const g = ctx.createLinearGradient(0, 0, r.width, r.height);
    g.addColorStop(0, "#ffc14d"); g.addColorStop(.5, "#faa71b"); g.addColorStop(1, "#e88f00");
    ctx.globalCompositeOperation = "source-over"; ctx.fillStyle = g; ctx.fillRect(0, 0, r.width, r.height);
    ctx.strokeStyle = "rgba(29, 20, 4, .16)"; ctx.lineWidth = 1.2;
    const R = 16, w = Math.sqrt(3) * R;
    for (let y = 0, row = 0; y < r.height + R; y += R * 1.5, row++) for (let x = row % 2 ? w / 2 : 0; x < r.width + w; x += w) {
      ctx.beginPath(); for (let i = 0; i < 6; i++) { const a = Math.PI / 3 * i + Math.PI / 6; ctx[i ? "lineTo" : "moveTo"](x + R * Math.cos(a), y + R * Math.sin(a)); } ctx.closePath(); ctx.stroke();
    }
    ctx.fillStyle = "#1d1404"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.font = "800 15px Archivo, system-ui, sans-serif"; ctx.fillText("SCRATCH HERE", r.width / 2, r.height / 2 - 2);
    ctx.font = "600 11.5px Archivo, system-ui, sans-serif"; ctx.fillText("drag your finger or mouse", r.width / 2, r.height / 2 + 18);
  };
  let drawing = false, last = null, moves = 0;
  const scratch = (x, y) => {
    ctx.globalCompositeOperation = "destination-out"; ctx.strokeStyle = "#000"; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.lineWidth = 38;
    ctx.beginPath(); ctx.moveTo(...(last || [x, y])); ctx.lineTo(x, y); ctx.stroke(); last = [x, y];
    if (++moves % 12 === 0) check();
  };
  const check = () => {
    const d = ctx.getImageData(0, 0, canvas.width, canvas.height).data; let clear = 0;
    for (let i = 3; i < d.length; i += 64) if (d[i] < 40) clear++;
    if (clear / (d.length / 64) > .4) reveal();
  };
  const pt = (e) => { const r = canvas.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  canvas.addEventListener("pointerdown", (e) => { if (revealed) return; drawing = true; last = null; canvas.setPointerCapture(e.pointerId); scratch(...pt(e)); });
  canvas.addEventListener("pointermove", (e) => { if (drawing) scratch(...pt(e)); });
  addEventListener("pointerup", () => { drawing = false; last = null; });

  const reveal = () => {
    if (revealed) return; revealed = true;
    canvas.classList.add("gone"); $(".pop-scratch", pop).classList.add("won"); $(".pop-reveal", pop).hidden = true;
    $(".pop-kick", pop).textContent = "You revealed"; $("#pop-h", pop).innerHTML = "Nice find. <span>Claim it below.</span>";
    form.hidden = false; setTimeout(() => input.focus(), reduce ? 0 : 350);
  };
  $(".pop-reveal", pop).addEventListener("click", reveal);

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const v = input.value.trim(), ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    $(".pop-err", pop).textContent = ok ? "" : "Please enter a valid email address.";
    input.setAttribute("aria-invalid", !ok); if (!ok) return input.focus();
    try { localStorage.setItem("bravado-pop-claimed", "1"); } catch (_) {}
    form.hidden = true; $(".pop-done", pop).hidden = false; $(".pop-no", pop).textContent = "Start shopping";
    $("#pop-h", pop).innerHTML = `${OFFER} is <span>all yours.</span>`; $(".pop-code", pop).focus();
  });
  $(".pop-code", pop).addEventListener("click", async (e) => {
    const b = e.currentTarget; try { await navigator.clipboard.writeText(CODE); } catch (_) {}
    $("span", b).textContent = "Copied"; setTimeout(() => ($("span", b).textContent = "Copy"), 1800);
  });

  /* ---------- open / close ---------- */
  const open = () => {
    if (!pop.hidden) return;
    lastFocus = document.activeElement; pop.hidden = false; document.body.classList.add("pop-on");
    requestAnimationFrame(() => { paint(); pop.classList.add("in"); $(".pop-x", pop).focus(); });
  };
  const close = () => {
    pop.classList.remove("in"); document.body.classList.remove("pop-on");
    setTimeout(() => (pop.hidden = true), reduce ? 0 : 300);
    if (lastFocus) lastFocus.focus();
  };
  pop.addEventListener("click", (e) => { if (e.target === pop || e.target.closest(".pop-x, .pop-no")) close(); });
  pop.addEventListener("keydown", (e) => {
    if (e.key === "Escape") return close();
    if (e.key === "Tab") { const f = $$("button, input", card).filter((x) => !x.closest("[hidden]") && !x.hidden); if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); } }
  });
  addEventListener("resize", () => { if (!pop.hidden && !revealed) paint(); });

  /* every page load: open as the best-sellers section (right after the main banner) comes into view; never over an open cart or search */
  const best = $("#best");
  const claimed = (() => { try { return !!localStorage.getItem("bravado-pop-claimed"); } catch (_) { return false; } })();
  if (best && !claimed && !navigator.webdriver) {
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const go = () => (document.body.matches(".cd-on, .srch-on, .pdp-open, .page-open") ? setTimeout(go, 3000) : open());
      go();
    }, { rootMargin: "0px 0px -35% 0px" });
    io.observe(best);
  }
  window.bravadoPop = { open };
})();
